<template>
    <div class="around-section" v-if="aroundArr != null" id="menu-link-around">
        <div class="container">
            <sectionTitle :options="[{ title : aroundArr.around_title}]"></sectionTitle>
            <sectionBaner :options="[{ bg: aroundArr.around_quote_img, title : aroundArr.around_quote_title, desc: aroundArr.around_quote_desc}]"></sectionBaner>
            <!-- <sectionDescColumn :options="[{ desc_left : aroundArr.around_desc_left, desc_right: aroundArr.around_desc_right}]"></sectionDescColumn> -->
            <div class="number-items">
                <div class="item" v-for="item in aroundArr.around_cards" :key="item.title">
                    <div class="item-img">
                        <img :src="item.img_num" alt="">
                        <span class="minute-num">{{  item.number}}</span>
                        <span class="minute-word">{{ aroundArr.around_minute_title }}</span>
                    </div>
                    <div class="item-title"><h4 v-html="item.title"></h4></div>
                    <div class="item-desc"><p v-html="item.desc"></p></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import sectionTitle from '@/components/partials/section-title.vue'
    import sectionBaner from '@/components/partials/section-baner.vue'
    // import sectionDescColumn from '@/components/partials/section-desc-column.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'around-section',
        data () {
            return {
            }
        },
        computed: mapGetters({
            aroundArr: 'loadAroundArr',
        }),
        components: {
            sectionTitle,
            sectionBaner,
            // sectionDescColumn,
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/around/around-section.scss';
    @import '@/styles/components/around/around-section-respond.scss';
</style>